export var ContentWidth;
(function (ContentWidth) {
    ContentWidth["CONTENT_WIDTH_UNKNOWN"] = "CONTENT_WIDTH_UNKNOWN";
    ContentWidth["DESKTOP_STANDARD"] = "DESKTOP_STANDARD";
})(ContentWidth || (ContentWidth = {}));
